module.exports = __webpack_public_path__ + "static/media/Agri-Retailers Infographic mobile 05-02-2024 C.277e5718.gif";